import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { OtherMeasurementAction, OtherMeasurementUnit } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';
import { Unit } from 'src/app/form-controls/shared/popovers/unit-popover/unit.popover';

interface OtherMeasuremenActionFormGroup {
	measurement: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-other-measurement-action-controls',
    templateUrl: './other-measurement-action-controls.component.html',
    styleUrls: ['../../../common.scss', './other-measurement-action-controls.component.scss'],
    imports: [ReactiveFormsModule, UnitQuantityControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OtherMeasurementActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: OtherMeasurementAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as OtherMeasurementAction;
	}

	@Input() form!: FormGroup<OtherMeasuremenActionFormGroup>;
	@Input() item!: Row | null;

	measurementUnits: Unit[] = [
		{ label: OtherMeasurementUnit.Kg },
		{ label: OtherMeasurementUnit.G },
		{ label: OtherMeasurementUnit.Mg },
		{ label: OtherMeasurementUnit.Ug },
		{ label: OtherMeasurementUnit.Ng },
		{ label: OtherMeasurementUnit.L },
		{ label: OtherMeasurementUnit.Ml },
		{ label: OtherMeasurementUnit.Percentage },
		{ label: OtherMeasurementUnit.Ms },
		{ label: OtherMeasurementUnit.Secs },
		{ label: OtherMeasurementUnit.Mins },
		{ label: OtherMeasurementUnit.Hrs },
		{ label: OtherMeasurementUnit.UL },
		{ label: OtherMeasurementUnit.Degrees },
		{ label: OtherMeasurementUnit.mmHg },
		{ label: OtherMeasurementUnit.HPF },
		{ label: OtherMeasurementUnit.NoUnits },
		{ label: OtherMeasurementUnit.Other }
	];

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('measurement', this.formBuilder.control(this.action?.measurement ?? null));
	}
}